
import { ChallengeData } from "@/models/Base/ChallengeData";
import { Game } from "@/models/Game";
import { ManhuntMapPoi } from "@/models/MapPois/ManHunt/ManhuntMapPoi";
import { cloneDeep, isEqual } from "lodash";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ChallengeBox from "../../../Base/ChallengeBox.vue";

@Component({
  components: {
    ChallengeBox,
  },
})
class PoiDefaultContent extends Vue {
  @Prop({ default: null }) readonly mapPoi!: ManhuntMapPoi;
  @Prop({ default: null }) readonly gameData!: Game;
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  showSavePanel = false;
  mapPoiClone = {} as ManhuntMapPoi;

  get getChallengeData(): ChallengeData {
    const challengeData = {} as ChallengeData;
    challengeData.text = this.mapPoi.default_content.txt.en;
    challengeData.image = this.mapPoi.default_content.h_thumb;
    if (
      this.mapPoi.default_content.video !== undefined &&
      this.mapPoi.default_content.video.en !== undefined
    ) {
      challengeData.video = this.mapPoi.default_content.video;
    } else {
      challengeData.video = { en: "" };
    }
    if (this.mapPoi.default_content.audio !== undefined) {
      challengeData.audio = this.mapPoi.default_content.audio;
    } else {
      challengeData.audio = { en: "" };
    }
    return challengeData;
  }

  get getImagePath(): string {
    return (
      "/gametype/" +
      this.gameData.gt_uid +
      "/seasons/" +
      this.gameData.seas_uid +
      "/img/poi/"
    );
  }

  get getAudioPath(): string {
    return (
      "/gametype/" +
      this.gameData.gt_uid +
      "/seasons/" +
      this.gameData.seas_uid +
      "/audio/poi/"
    );
  }
  get getVideoPath(): string {
    return (
      "/gametype/" +
      this.gameData.gt_uid +
      "/seasons/" +
      this.gameData.seas_uid +
      "/video/poi/"
    );
  }

  created(): void {
    this.mapPoiClone = cloneDeep(this.mapPoi);
  }

  onDataChange(challenge: ChallengeData): void {
    this.mapPoi.default_content.txt.en = challenge.text;
    this.mapPoi.default_content.h_thumb = challenge.image;
    this.mapPoi.default_content.video = challenge.video;
    this.mapPoi.default_content.audio = challenge.audio;
    if (!isEqual(this.mapPoi, this.mapPoiClone)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
    this.$emit("updateTempObject", this.mapPoi);
  }
  @Watch("isSavedOrDiscard")
  onisSaveOrDiscardChanged(value: boolean): void {
    if (value) {
      this.showSavePanel = false;
    }
  }
}

export default PoiDefaultContent;
